import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './permission' // permission control

//引入element组件库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import api from '@/api/api.js'
import request from '@/utils/request'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js' ;

import * as filters from '@/filters/filters'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(ElementUI);

Vue.prototype.request = request
Vue.prototype.api = api

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js' ;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
